import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RecaptchaService } from '../services/recaptcha/recaptcha.service';

export const recaptchaInterceptor: HttpInterceptorFn = (req, next) => {
  const recaptcha = inject(RecaptchaService);

  // Apply reCAPTCHA only for calls to the Account Manager API
  if (!req.url.startsWith(environment.accountManagerApiBaseUrl)) {
    return next(req);
  }

  return from(recaptcha.execute('api_request')).pipe(
    switchMap((token) => {
      const headers = token ? req.headers.set('X-Recaptcha-Token', token) : req.headers;
      return next(req.clone({ headers }));
    }),
  );
};
